import styled from 'styled-components';
import { variables } from '../../../styles/variables';

export const FormsContainer = styled.div`
  @media (max-width: 1500px) and (min-width: 769px) {
    width: 100%;
    padding-right: 10px;
  }
`;
export const FormHeader = styled.h4`
  font-size: 1.8rem;
  margin: 2.4rem 0 1rem 0;
  font-weight: 700;
  color: ${variables.colorGrey};
`;

export const JustifiedBox = styled.div``;
